"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UN_LOCK = exports.UNRECOVERABLE_STATES = exports.UNFINISHED_FEATURE = exports.TOTAL_WIN_FORMATED = exports.SPIN_END = exports.SLOW_SERVER_RESPONSE = exports.SET_WIN_COUNTER = exports.SET_SPIN_STOP_WAIT = exports.SET_SAVED_REELS = exports.SET_ROUND_ID = exports.SET_REELS = exports.SERVER_GAME_READY = exports.ReelControlState = exports.ROUND_VOID = exports.ROUND_START = exports.ROUND_END = exports.RESPIN_PLAYED = exports.REELS_STOPPING = exports.REELS_STOPPED = exports.REELS_STATE_STOPPED = exports.REELS_STATE_SPINNING = exports.REELS_SPINNING = exports.REELS_SPIN = exports.QUICK_STOP_AVAILABLE = exports.QUICK_STOP = exports.PRESENTATION_STOP_RESET = exports.PRESENTATION_STOP_AVAILABLE = exports.PRESENTATION_STOP = exports.PAYLINE_WIN = exports.LOCK = exports.KEEP_ALIVE_STOP = exports.KEEP_ALIVE_STARTED = exports.KEEP_ALIVE_START = exports.IDLE = exports.HYPER_SPIN_STOP = exports.HYPER_SPIN_START = exports.GAME_WINCOUNTER_SET = exports.GAME_WINCOUNTER_ADD = exports.GAME_STATUS_SET = exports.GAME_READY = exports.GAME_PLAYER_INPUT_WAIT = exports.GAME_PLAYER_INPUT = exports.GAME_MAX_WIN = exports.GAME_FEATURE_START = exports.GAME_FEATURE_END = exports.GAME_COUNT_FEATURE_AS_LINE = exports.FREE_SPIN_SPINNING = exports.FREE_SPIN_PLAYED = exports.FREE_SPINS_WON = exports.ExitReason = exports.EXIT_TO = exports.EXITING = exports.EXIT = exports.Collection = exports.COLLECTION_UPDATE = exports.COLLECTIONS_UPDATE = exports.BIG_WIN = exports.BIGWIN_START = exports.BIGWIN_END = void 0;
var _GameStatus = require("../enums/GameStatus");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ReelControlState = exports.ReelControlState = /*#__PURE__*/function (ReelControlState) {
  ReelControlState[ReelControlState["Starting"] = 0] = "Starting";
  ReelControlState[ReelControlState["Spinning"] = 1] = "Spinning";
  ReelControlState[ReelControlState["Stopping"] = 2] = "Stopping";
  ReelControlState[ReelControlState["Stopped"] = 3] = "Stopped";
  return ReelControlState;
}({});
var UNRECOVERABLE_STATES = exports.UNRECOVERABLE_STATES = [_GameStatus.GameStatus.InvalidToken, _GameStatus.GameStatus.PlayerLocked, _GameStatus.GameStatus.ContactSupport, _GameStatus.GameStatus.InvalidPlayerId, _GameStatus.GameStatus.APIDown, _GameStatus.GameStatus.Timeout, _GameStatus.GameStatus.Error, _GameStatus.GameStatus.FailedToConnect, _GameStatus.GameStatus.Disconnected];
var SET_SPIN_STOP_WAIT = exports.SET_SPIN_STOP_WAIT = "SET_SPIN_STOP_WAIT";
var GAME_READY = exports.GAME_READY = "GAME_READY";
var SET_REELS = exports.SET_REELS = "SET_REELS";
var SET_SAVED_REELS = exports.SET_SAVED_REELS = "SET_SAVED_REELS";
var ROUND_START = exports.ROUND_START = "ROUND_START";
var ROUND_END = exports.ROUND_END = "ROUND_END";
var IDLE = exports.IDLE = "IDLE";
var SPIN_END = exports.SPIN_END = "SPIN_END";

//Used when server responded with no bet, ie no balance, limits reached etc.
var ROUND_VOID = exports.ROUND_VOID = "ROUND_VOID";
var TOTAL_WIN_FORMATED = exports.TOTAL_WIN_FORMATED = "TOTAL_WIN_FORMATED";
var PRESENTATION_STOP = exports.PRESENTATION_STOP = "PRESENTATION_STOP";
var PAYLINE_WIN = exports.PAYLINE_WIN = "PAYLINE_WIN";
var FREE_SPINS_WON = exports.FREE_SPINS_WON = "FREE_SPINS_WON";
var FREE_SPIN_PLAYED = exports.FREE_SPIN_PLAYED = "FREE_SPIN_PLAYED";
var FREE_SPIN_SPINNING = exports.FREE_SPIN_SPINNING = "FREE_SPIN_SPINNING";

/** Note that this will end the feature. this is a special for the respin feature. */
var RESPIN_PLAYED = exports.RESPIN_PLAYED = "RESPIN_PLAYED";

/** an unfinshed feature needs to be finished, used to set game state and trigger controller calls */
var UNFINISHED_FEATURE = exports.UNFINISHED_FEATURE = "UNFINISHED_FEATURE";

/** set current round id */
var SET_ROUND_ID = exports.SET_ROUND_ID = "SET_ROUND_ID";

/** trigger when game server is slow to respond to a start. */
var SLOW_SERVER_RESPONSE = exports.SLOW_SERVER_RESPONSE = "SLOW_SERVER_RESPONSE";

/** Hard set win counter. */
var SET_WIN_COUNTER = exports.SET_WIN_COUNTER = "SET_WIN_COUNTER";
var REELS_SPIN = exports.REELS_SPIN = "REELS_SPIN";
var REELS_SPINNING = exports.REELS_SPINNING = "REELS_SPINNING";
var REELS_STOPPING = exports.REELS_STOPPING = "REELS_STOPPING";
var REELS_STOPPED = exports.REELS_STOPPED = "REELS_STOPPED";
var REELS_STATE_SPINNING = exports.REELS_STATE_SPINNING = "REELS_STATE_SPINNING";
var REELS_STATE_STOPPED = exports.REELS_STATE_STOPPED = "REELS_STATE_STOPPED";

/**
 * Quickstop available to player.
 */
var QUICK_STOP_AVAILABLE = exports.QUICK_STOP_AVAILABLE = "QUICK_STOP_AVAILABLE";
/**
 * Perform quick stop
 */
var QUICK_STOP = exports.QUICK_STOP = "QUICK_STOP";
var GAME_FEATURE_START = exports.GAME_FEATURE_START = "GAME_FEATURE_START";
var GAME_FEATURE_END = exports.GAME_FEATURE_END = "GAME_FEATURE_END";
var BIG_WIN = exports.BIG_WIN = "BIG_WIN";
var BIGWIN_START = exports.BIGWIN_START = "BIGWIN_START";
var BIGWIN_END = exports.BIGWIN_END = "BIGWIN_END";
var GAME_STATUS_SET = exports.GAME_STATUS_SET = "GAME_STATUS_SET";
var GAME_WINCOUNTER_SET = exports.GAME_WINCOUNTER_SET = "GAME_WINCOUNTER_SET";
var GAME_WINCOUNTER_ADD = exports.GAME_WINCOUNTER_ADD = "GAME_WINCOUNTER_ADD";

/**
 * Server said game ready, includes reconnect handling etc. 
 */
var SERVER_GAME_READY = exports.SERVER_GAME_READY = "SERVER_GAME_READY";

/** Player won the max win */
var GAME_MAX_WIN = exports.GAME_MAX_WIN = "GAME_MAX_WIN";

/**
 * Game is waiting for player input such as freespin dialog
 */
var GAME_PLAYER_INPUT_WAIT = exports.GAME_PLAYER_INPUT_WAIT = "GAME_PLAYER_INPUT_WAIT";
/** player inputgiven */
var GAME_PLAYER_INPUT = exports.GAME_PLAYER_INPUT = "GAME_PLAYER_INPUT";

/// Starts the keep alive during features.
var KEEP_ALIVE_START = exports.KEEP_ALIVE_START = "KEEP_ALIVE_START";
var KEEP_ALIVE_STARTED = exports.KEEP_ALIVE_STARTED = "KEEP_ALIVE_STARTED";
var KEEP_ALIVE_STOP = exports.KEEP_ALIVE_STOP = "KEEP_ALIVE_STOP";
var HYPER_SPIN_START = exports.HYPER_SPIN_START = "HYPER_SPIN_START";
var HYPER_SPIN_STOP = exports.HYPER_SPIN_STOP = "HYPER_SPIN_STOP";
var COLLECTIONS_UPDATE = exports.COLLECTIONS_UPDATE = "COLLECTIONS_UPDATE";
var COLLECTION_UPDATE = exports.COLLECTION_UPDATE = "COLLECTION_UPDATE";
var GAME_COUNT_FEATURE_AS_LINE = exports.GAME_COUNT_FEATURE_AS_LINE = "GAME_COUNT_FEATURE_AS_LINE";

/** Game saying player can now skip a presentation */
var PRESENTATION_STOP_AVAILABLE = exports.PRESENTATION_STOP_AVAILABLE = "PRESENTATION_STOP_AVAILABLE";
/** Game saying that the previous available is now voided.  */
var PRESENTATION_STOP_RESET = exports.PRESENTATION_STOP_RESET = "PRESENTATION_STOP_RESET";
var LOCK = exports.LOCK = "LOCK";
var UN_LOCK = exports.UN_LOCK = "UN_LOCK";

// Request exit, will be validated
var EXIT = exports.EXIT = "EXIT";
// Request exit, will be validated, url in payload.
var EXIT_TO = exports.EXIT_TO = "EXIT_TO";

/// exit will happen.
var EXITING = exports.EXITING = "EXITING";
var ExitReason = exports.ExitReason = /*#__PURE__*/function (ExitReason) {
  ExitReason[ExitReason["Regular"] = 0] = "Regular";
  ExitReason[ExitReason["RealityCheck"] = 1] = "RealityCheck";
  ExitReason[ExitReason["RealityCheckHistory"] = 2] = "RealityCheckHistory";
  ExitReason[ExitReason["PlayForReal"] = 3] = "PlayForReal";
  return ExitReason;
}({});
/**
 * Each bet value that a player has made a bet on and actually collected an item.
 * 
 * Note that this is unique per bet value to prevent abuse.
 */
var Collection = exports.Collection = /*#__PURE__*/_createClass(function Collection() {
  _classCallCheck(this, Collection);
  /** Bet value this is the collection for */
  _defineProperty(this, "betAmount", void 0);
  /** Number of items collected */
  _defineProperty(this, "count", void 0);
  /** if the collection is linked to a symbol or item. Used if a game have mulitple collects as well. */
  _defineProperty(this, "symbol", void 0);
}); //export type BalanceActionTypes = UpdateBalanceAction | UpdateFormattedBalanceAction;
//# sourceMappingURL=types.js.map